var Renderer = function () {
  document.querySelectorAll('script[type="text/x-handlebars-template"]').forEach((template, key, parent) => {
    const partialName = template.id.replace('-partial', '')
    Handlebars.registerPartial(partialName, template.innerHTML)
  })

  this.label = function () {
    return Handlebars.helpers.label.apply(this, arguments)
  }

  this.render = function (templateId, templateParams) {
    return this.template(templateId)($.extend({}, templateParams, Labels))
  }

  this.template = function (templateId) {
    let template = document.getElementById(templateId)
    if (!template) throw new Error("Template not found: " + templateId)
    return Handlebars.compile(template.innerHTML);
  }
}
